import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, y = 28, className }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-70px" }}
            transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
        >
            {children}
        </motion.div>
    );
}

export function Eyebrow({ children, dark = false }) {
    return (
        <p
            className={`font-mono-accent text-xs tracking-[0.28em] uppercase ${
                dark ? "text-[#D8BC7A]" : "text-[#C9A24B]"
            }`}
        >
            {children}
        </p>
    );
}
